import { render } from "./routerformulir.vue?vue&type=template&id=fe3e6b34"
import script from "./routerformulir.vue?vue&type=script&lang=js"
export * from "./routerformulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__